import { z } from "zod";

// Branded ids — a MatchId can never be passed where a PlayerId is expected.
export const PlayerId = z.string().uuid().brand<"PlayerId">();
export const MatchId = z.string().uuid().brand<"MatchId">();
export const NightId = z.string().uuid().brand<"NightId">();
export const VaultItemId = z.string().uuid().brand<"VaultItemId">();
export const PoolId = z.string().uuid().brand<"PoolId">();
export const InventoryId = z.string().uuid().brand<"InventoryId">();
export const BatchId = z.string().uuid().brand<"BatchId">();
export const OrderId = z.string().uuid().brand<"OrderId">();
export const RollId = z.string().uuid().brand<"RollId">();
export const SessionId = z.string().uuid().brand<"SessionId">();
export const ThreadId = z.string().uuid().brand<"ThreadId">();

export type PlayerId = z.infer<typeof PlayerId>;
export type MatchId = z.infer<typeof MatchId>;
export type NightId = z.infer<typeof NightId>;
export type VaultItemId = z.infer<typeof VaultItemId>;
export type PoolId = z.infer<typeof PoolId>;
export type InventoryId = z.infer<typeof InventoryId>;
export type BatchId = z.infer<typeof BatchId>;
export type OrderId = z.infer<typeof OrderId>;
export type RollId = z.infer<typeof RollId>;
export type SessionId = z.infer<typeof SessionId>;
export type ThreadId = z.infer<typeof ThreadId>;

export const IsoTimestamp = z.string().datetime({ offset: true });
export type IsoTimestamp = z.infer<typeof IsoTimestamp>;
